import React from 'react';
const CHECKOUT_URL = 'https://checkout.ecompradigital.online/cart/46114651766972:1';
export function MidCTASection() {
  return <section className="relative bg-neutral-bg py-6 px-4 text-center border-y border-neutral-beige overflow-hidden" data-id="element-72">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent opacity-60" data-id="element-73"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-74">
        <div className="relative inline-block group" data-id="element-75">
          <div className="absolute -inset-1 bg-gradient-to-r from-garden-medium to-garden-dark rounded-full blur opacity-40 group-hover:opacity-75 transition duration-500 animate-pulse-glow" data-id="element-76"></div>
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="relative inline-flex items-center justify-center bg-gradient-garden hover:from-[#1e3d25] hover:to-garden-dark text-white font-black text-lg sm:text-xl py-4 px-10 rounded-full shadow-xl transform transition-all duration-300 hover:-translate-y-1" data-id="element-77">
            👉 QUIERO EMPEZAR MI HUERTA HOY
          </a>
        </div>
      </div>
    </section>;
}